let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2uoBF"), load("fqBFU")]).then(() => parcelRequire('gQsLh'));